import { Search, Loader2 } from "lucide-react";
import { useGeocode } from "@/hooks/useGeocode";

export const SearchBar = ({ onSelect }) => {
  const { query, results, loading, noResults, search, clear } = useGeocode();

  return (
    <div className="relative">
      <div className="flex items-center gap-2 bg-white/5 border border-white/10 rounded-full px-4 py-2.5 focus-within:border-[#2ec4b6]/50 transition-colors">
        {loading ? <Loader2 size={15} className="text-zinc-500 animate-spin shrink-0" /> : <Search size={15} className="text-zinc-500 shrink-0" />}
        <input
          data-testid="location-search-input"
          value={query}
          onChange={(e) => search(e.target.value)}
          placeholder="Address, postcode or place…"
          className="bg-transparent outline-none text-sm w-full placeholder:text-zinc-400 text-zinc-100"
        />
      </div>
      {(results.length > 0 || noResults) && (
        <div className="absolute top-full mt-2 left-0 right-0 bg-black/85 backdrop-blur-xl border border-white/10 rounded-2xl overflow-hidden z-50 shadow-2xl">
          {noResults && (
            <p data-testid="search-no-results" className="px-4 py-3 text-sm text-zinc-300">
              No UK match found — try adding a postcode or town name.
            </p>
          )}
          {results.map((r) => (
            <button
              key={r.place_id}
              data-testid="search-result-item"
              onClick={() => {
                onSelect(r.lat, r.lng, r.display_name);
                clear(r.display_name);
              }}
              className="block w-full text-left px-4 py-2.5 text-sm text-zinc-100 hover:bg-white/10 transition-colors border-b border-white/5 last:border-0"
            >
              {r.display_name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
